import React from "react";
import Chart from "react-apexcharts";
import { Grid, Chip, Box, Stack, Avatar } from "@mui/material";
import GroupsIcon from "@mui/icons-material/Groups";
import DonutLargeIcon from "@mui/icons-material/DonutLarge";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialTypography from "../../../../components/MaterialTypography";


const TaskChartCard = () => {
    const chartOptions = {
        chart: {
            type: "line",
            toolbar: { show: false },
            zoom: { enabled: false },
            fontFamily: "inherit",
        },
        colors: ["#26a69a", "#ff9800", "#e0e0e0"], 
        stroke: {
            curve: "smooth", 
            width: 2,
            dashArray: [0, 5, 0], 
        },
        xaxis: {
            categories: [
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sept",
                "Oct",
                "Nov",
                "Dec",
            ],
            axisBorder: { show: false },
            axisTicks: { show: false },
            labels: {
                style: { colors: "#9e9e9e", fontSize: "12px" },
            },
        },
        yaxis: {
            show: true,
            labels: {
                style: { colors: "#9e9e9e", fontSize: "12px" },
            },
        },
        grid: {
            borderColor: "#f5f5f5",
            strokeDashArray: 4,
        },
        legend: { show: false },
        dataLabels: { enabled: false },
        tooltip: {
            enabled: true,
            x: { show: true },
        },
    };

    const chartSeries = [
        {
            name: "Designer",
            data: [20, 18, 25, 20, 20, 25, 20, 14, 20],
        },
        {
            name: "Developer",
            data: [10, 10, 17, 17, 11, 20, 25, 30, 30],
        },
        {
            name: "Testing",
            data: [40, 35, 35, 28, 28, 25, 20, 20, 28],
        },
    ];

    return (
        <MaterialBox
            sx={{
                border: '1px solid #ccd2d9',
                borderRadius: 3,
                padding: 1,
                height: "100%",
            }}
        >
            <Grid container spacing={1}>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Stack spacing={1}>
                        <MaterialBox sx={{ display: 'flex', flexDirection: 'row', gap: 0.5, alignItems: 'center' }}>
                            <MaterialBox sx={{ width: '6px', height: '12px', borderRadius: '30%', backgroundColor: '#5682e8' }} />
                            <MaterialTypography variant='body2' fontWeight='bold' color='dark'>Total task Details</MaterialTypography>
                        </MaterialBox>
                        <Stack direction="row" alignItems="center" spacing={1}>
                            <MaterialTypography variant="h3" fontWeight="bold">
                                59
                            </MaterialTypography>
                        </Stack>
                        <Stack direction="row" alignItems="center" spacing={1}>
                            <Chip
                                label="80 task"
                                size="small"
                                sx={{
                                    backgroundColor: "#e0f2f1",
                                    color: "#009688",
                                    fontWeight: "bold",
                                    borderRadius: "6px",
                                    height: "20px",
                                    fontSize: "10px",
                                }}
                            />
                            <MaterialTypography variant="caption" color="textSecondary">
                                vs last baseline
                            </MaterialTypography>
                        </Stack>
                    </Stack>
                </Grid>

                <Grid size={{ xs: 12, md: 8 }}>
                    <Chart
                        options={chartOptions}
                        series={chartSeries}
                        type="line"
                        height={200}
                        width="100%"
                    />
                </Grid>
            </Grid>


            <Grid container spacing={2} justifyContent="space-between">
                <Grid size={{ xs: 12, md: 4 }}>
                    <Stack spacing={0.5}>
                        <MaterialTypography variant="body2" color="textPrimary" fontWeight="bold">
                            Total member
                        </MaterialTypography>
                        <Stack direction="row" alignItems="center" spacing={1}>
                            <MaterialTypography variant="body2" >
                                24
                            </MaterialTypography>
                        </Stack>
                    </Stack>
                </Grid>


                <Grid size={{ xs: 12, md: 4 }} sx={{ borderLeft: '1px solid #f0f0f0', pl: { xs: 1, md: 3 } }}>
                    <Stack spacing={0.5}>
                        <MaterialTypography variant="body2" color="textPrimary" fontWeight="bold">
                            Percentage
                        </MaterialTypography>
                        <Stack direction="row" alignItems="center" spacing={1}>
                            <MaterialTypography variant="body2" >
                                80%
                            </MaterialTypography>
                        </Stack>
                    </Stack>
                </Grid>


                <Grid size={{ xs: 12, md: 4 }} sx={{ borderLeft: '1px solid #f0f0f0', pl: { xs: 1, md: 3 } }}>
                    <Stack spacing={0.5}>
                        <MaterialTypography variant="body2" color="textPrimary" fontWeight="bold">
                            Baselines
                        </MaterialTypography>
                        <Stack direction="row" alignItems="center" spacing={1}>
                            <MaterialTypography variant="body2" >
                                12
                            </MaterialTypography>
                        </Stack>
                    </Stack>
                </Grid>

            </Grid>
        </MaterialBox>
    );
};

export default TaskChartCard;